import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { AbstractSecurityStorage, AuthInterceptor, AuthModule, DefaultLocalStorageService, LogLevel, OpenIdConfiguration, StsConfigHttpLoader, StsConfigLoader } from "angular-auth-oidc-client";
import { Observable } from "rxjs";
import { BrowserConfig } from "src/_services";
import { AuthService } from "./auth.service";

export const authFactory1 = () => {
    const obsConfig = new Observable<OpenIdConfiguration>((observer) => {
      new Promise(async (resolve) => {
        while (!BrowserConfig.loaded) {
          await new Promise((resolve) => setTimeout(() => {
            resolve('');
          }, 800))
        }
        resolve('');
      }).then(() => {
        observer.next({
            authority: BrowserConfig.openiddictsettings.authority,
            redirectUrl: BrowserConfig.openiddictsettings.redirectUrl,
            postLogoutRedirectUri: BrowserConfig.openiddictsettings.postLogoutRedirectUri,
            clientId: BrowserConfig.openiddictsettings.clientId,
            //scope: 'openid roles profile',
            scope: BrowserConfig.openiddictsettings.scope,
            responseType: BrowserConfig.openiddictsettings.responseType,
            silentRenew: BrowserConfig.openiddictsettings.silentRenew,
            renewTimeBeforeTokenExpiresInSeconds: BrowserConfig.openiddictsettings.renewTimeBeforeTokenExpiresInSeconds,
            useRefreshToken: BrowserConfig.openiddictsettings.useRefreshToken,
            ignoreNonceAfterRefresh: BrowserConfig.openiddictsettings.ignoreNonceAfterRefresh,
            
            logLevel: LogLevel.Debug,
            //use the built in interceptor to add the accesstokens to your request
            secureRoutes: [
                `${BrowserConfig.apiBaseDomain}`,
                `${BrowserConfig.apiBaseDomain}/utenti/preferiti`
                
            ],
        });
        observer.complete();
      })
    });
    return new StsConfigHttpLoader(obsConfig);
  };

  @NgModule({ declarations: [],
    exports: [AuthModule], imports: [CommonModule,
        RouterModule,
        AuthModule.forRoot({
            loader: {
                provide: StsConfigLoader,
                useFactory: authFactory1,
                deps: [],
            },
        })], providers: [
        {
            provide: AbstractSecurityStorage,
            useClass: DefaultLocalStorageService,
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
  export class ComparatoreAuthModule {
  
    static forRoot(): ModuleWithProviders<ComparatoreAuthModule> {
      return {
        ngModule: ComparatoreAuthModule,
        providers: [
          AuthService,
          { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
        ]
      }
    }
  }